// extracted by mini-css-extract-plugin
export default {"container":"z890hl"};